import { langFallback$Fetch } from '../../lang/utils/langfetch'
import { csrfTokenService } from '../csrf/CsrfTokenService'
import { PaymentCard, paymentCardSchema } from './schema'

export class UserStoredCardsRepositoryFetch {
  async readAll(langCode: string): Promise<PaymentCard[]> {
    const results: any = await langFallback$Fetch(
      langCode,
      '/_/users/stored-cards/',
    )
    return this.mappedCards(results.cards)
  }

  private mappedCards(cards): PaymentCard[] {
    return cards.map((card) => {
      return paymentCardSchema.parse({
        brand: card.brand,
        expMonth: card.exp_month.toString(),
        expYear: card.exp_year.toString(),
        id: card.id.toString(),
        last4: card.last4.toString(),
        canDelete: card.can_delete,
      })
    })
  }

  async delete(cardId: string, langCode: string) {
    const { csrfToken } = await csrfTokenService()
    return langFallback$Fetch(langCode, `/_/users/stored-cards/${cardId}/`, {
      method: 'DELETE',
      headers: {
        'X-CSRFToken': csrfToken,
      },
    })
  }
}
